import './Legal.css';

export default function ChildSafety() {
  return (
    <div className="legal-page">
      <nav className="legal-nav">
        <a href="/" className="legal-nav-logo"><span className="logo-o">O</span>urStory</a>
      </nav>
      <div className="legal-content container">
        <div className="legal-header">
          <a href="/" className="legal-back">← Back</a>
          <h1>Child Safety Standards</h1>
          <p className="legal-date">Last updated: April 2026</p>
          <p className="legal-intro">OurStory is committed to the safety and protection of minors. This page outlines our child safety standards and how we comply with applicable policies.</p>
        </div>
        <div className="legal-section">
          <h2>Age requirement</h2>
          <p>OurStory requires all users to be at least 16 years of age. We enforce this through a mandatory age verification step during onboarding. Users who do not meet the age requirement are not permitted to create an account or access the app.</p>
        </div>
        <div className="legal-section">
          <h2>Content moderation</h2>
          <p>All user-generated content is screened by an AI-powered moderation system before appearing in the community feed. Content that violates our Community Guidelines — including any content that exploits, endangers, or is inappropriate for minors — is automatically flagged and removed. Our moderation team reviews flagged content within 24 hours.</p>
        </div>
        <div className="legal-section">
          <h2>Reporting mechanism</h2>
          <p>Every story in the app has a built-in reporting feature accessible via the options menu. Users can report content for violations including inappropriate content. All reports are reviewed by our team promptly. Users can also contact us directly at theourstoryapp@gmail.com to report concerns.</p>
        </div>
        <div className="legal-section">
          <h2>Zero tolerance policy</h2>
          <p>OurStory has a zero tolerance policy for child sexual abuse material (CSAM) or any content that sexualizes, exploits, or endangers minors. Any such content will be immediately removed and reported to the appropriate authorities, including the National Center for Missing and Exploited Children (NCMEC).</p>
        </div>
        <div className="legal-section">
          <h2>User blocking and safety tools</h2>
          <p>Users can block other users at any time. Blocked users' content is immediately removed from the blocking user's feed. Users can also report accounts for abusive behavior, which triggers an immediate review by our moderation team.</p>
        </div>
        <div className="legal-section">
          <h2>Contact us</h2>
          <p>If you have concerns about child safety on OurStory, please contact us immediately at <a href="mailto:info@theourstoryapp.com" style={{color: '#b8d4b8'}}>theourstoryapp@gmail.com</a>. We take all reports seriously and respond promptly.</p>
        </div>
      </div>
      <footer className="legal-footer">
        <p>© 2026 OurStory · <a href="mailto:info@theourstoryapp.com">theourstoryapp@gmail.com</a></p>
      </footer>
    </div>
  );
}
